import { useBranding } from "../lib/branding";

export const Logo = ({
  dark = false,
  testid = "brand-logo",
  variant = "website",
}) => {
  const b = useBranding();
  const logo = variant === "report" ? b?.report_logo : b?.website_logo;
  const source = logo || b?.logo;
  if (source) {
    return (
      <div
        className={`flex items-center ${dark ? "rounded-md bg-white px-2 py-1" : ""}`}
        data-testid={testid}
      >
        <img
          src={source}
          alt={b.company || "Company logo"}
          className="h-9 max-w-[190px] object-contain"
          data-testid="brand-logo-image"
        />
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2.5" data-testid={testid}>
      <div
        className={`h-8 w-8 rounded-md grid place-items-center ${dark ? "bg-teal-500" : "bg-slate-900"}`}
      >
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5"
          fill="none"
          stroke={dark ? "#0F172A" : "#2DD4BF"}
          strokeWidth="2.4"
        >
          <path d="M3 11l9-7 9 7v9a1 1 0 01-1 1H4a1 1 0 01-1-1z" />
          <path d="M8.5 14.5l2.5 2.5 5-5" />
        </svg>
      </div>
      <div className="leading-none">
        <div
          className={`font-display font-extrabold text-[17px] ${dark ? "text-white" : "text-slate-900"}`}
        >
          POSSESSION<span className="text-teal-500">CHECK</span>
        </div>
        <div
          className={`font-mono text-[9px] tracking-[0.18em] mt-1 ${dark ? "text-slate-400" : "text-slate-500"}`}
        >
          PROFESSIONAL HOME INSPECTION
        </div>
      </div>
    </div>
  );
};
